<template>
    <div>
        <aside
            class="left-sidebar"
            data-sidebarbg="skin5"
            v-bind:class="{ min: activarLateral }"
        >
            <div class="scroll-sidebar">
                <nav class="sidebar-nav">
                    <ul id="sidebarnav">
                        <li
                            class="sidebar-item"
                            v-for="i in menuItems"
                            :key="i.m_id"
                            v-bind:class="{ sub: i.type === 2 }"
                        >
                            <router-link
                                :to="i.ruta"
                                exact-active-class="active"
                                class="sidebar-link waves-effect waves-dark type1"
                                v-if="i.type == 1"
                            >
                                <i :class="i.icon"></i>
                                <span class="hide-menu">{{ i.name }}</span>
                            </router-link>
                            <div v-else-if="i.type == 2"
                                class="sidebar-link has-arrow waves-effect waves-dark"
                                v-on:click="activeSubMenu(i)"
                                v-bind:class="{ active: i.mActive }"
                                aria-expanded="false"
                            >
                                <i :class="i.icon"></i>
                                <span class="hide-menu">{{ i.name }} </span>
                            </div>

                            <ul
                                aria-expanded="false"
                                class="collapse first-level"
                                v-if="i.mActive > 0"
                                v-bind:class="{ in: i.mActive }"
                            >
                                <li
                                    class="sidebar-item"
                                    v-for="(item, index) in i.items"
                                    :key="index"
                                >
                                    <router-link
                                        :to="item.ruta"
                                        exact-active-class="active"
                                        class="sidebar-link"
                                    >
                                        <span class="hide-menu">{{ item.name }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
                <div class="btnAsideAction" @click="ShowHiddenAside">
                    <i
                        class="fas fa-chevron-left"
                        v-bind:class="{ min: activarLateral }"
                    ></i>
                </div>
            </div>
        </aside>
    </div>
</template>
<script>
export default {
    name: "Aside_bSales",
    data() {
        return {
            activarLateral: false,
            winnerWidth: window.innerWidth,
            menuLateral: [],
            submenu1: 0,
            submenu2: 0,
        };
    },
    created() {
        this.estructuraMenu();
        this.printOrderMenuOut();
    },
    methods: {
        ShowHiddenAside() {
            this.activarLateral = !this.activarLateral;
            this.$emit("activarLateral", this.activarLateral);
        },
        printOrderMenuOut() {
            const hiddenByRouteName = ["Insurance"];
            const orderByRouteName = ["Dash_bSales", "Campaigns_bSales", "Landing_bSales", "Leads_bSales", "Retail", "Insurance", "Setting_bSales"];
            return this.menuLateral
                .map(i => {
                    const routeName = i.ruta.name;
                    const order = orderByRouteName.indexOf(routeName);

                    return {
                        ...i,
                        hidden: hiddenByRouteName.includes(routeName),
                        order: order >= 0 ? order : Number.MAX_SAFE_INTEGER,
                    };
                })
                .sort((a, b) => a.order - b.order);
        },
        estructuraMenu() {
            // order: controla el orden de renderizado (independiente de la posición en el array)
            // hidden: true oculta el ítem del menú sin borrarlo
            this.menuLateral = [
                {
                    name: "Leads",
                    ruta: { name: "Leads_bSales" },
                    icon: "fas fa-user",
                    type: 1,
                    m_id: 0,
                    items: [],
                    order: 0,
                    hidden: false,
                },
                {
                    name: "Jobs",
                    ruta: { name: "Retail" },
                    icon: "fas fa-chart-line",
                    type: 1,
                    mActive: 0,
                    items: [],
                    m_id: 1,
                    order: 1,
                    hidden: false,
                },
                {
                    name: "Jobs Insurance",
                    ruta: { name: "Insurance" },
                    icon: "fas fa-chart-line",
                    type: 1,
                    mActive: 0,
                    items: [],
                    m_id: 2,
                    order: 2,
                    hidden: true,
                },
                {
                    name: "Dashboard",
                    ruta: { name: "Dash_bSales" },
                    icon: "fas fa-tachometer-alt",
                    type: 1,
                    mActive: 0,
                    items: [],
                    m_id: 4,
                    order: 3,
                    hidden: false,
                },
                {
                    name: "Campaigns",
                    ruta: { name: "Campaigns_bSales" },
                    icon: "fas fa-bullhorn",
                    type: 1,
                    mActive: 0,
                    items: [],
                    m_id: 5,
                    order: 4,
                    hidden: false,
                },
                {
                    name: "Landing",
                    ruta: { name: "Landing_bSales" },
                    icon: "fas fa-globe",
                    type: 1,
                    mActive: 0,
                    items: [],
                    m_id: 6,
                    order: 5,
                    hidden: false,
                },
                {
                    name: "Setting",
                    ruta: { name: "Setting_bSales" },
                    icon: "fas fa-cog",
                    type: 1,
                    mActive: 0,
                    items: [],
                    m_id: 3,
                    order: 5,
                    hidden: false,
                },
            ];
        },
        validarMenu(menuLateral) {
            // @ts-ignore
            const userType = window.user_type;

            if (userType == 0) {
                this.submenu1 = 0;
                this.submenu2 = 0;
                return menuLateral;
            }

            return menuLateral.filter(i => i.ruta.name === "Retail");
        },
        activeSubMenu(i) {
            console.log('activeSubMenu', i)
            let menuLateral = this.menuLateral
            for (const j in menuLateral) {
                if (menuLateral[j].mActive !== undefined) {
                    if (menuLateral[j].mActive && menuLateral[j] != i) {
                        this.menuLateral[j].mActive = false;
                    }
                    if(menuLateral[j] == i) {
                        this.menuLateral[j].mActive = !this.menuLateral[j].mActive;
                    }
                }
            }
        },
    },
    computed: {
        menuItems() {
            return this.printOrderMenuOut()
                .filter(i => !i.hidden);
        },
    },
    mounted: function () {
        if (this.winnerWidth < 1050) {
            this.ShowHiddenAside();
        }
    },
};
</script>
<style lang="scss" scoped>
.left-sidebar {
    position: fixed;
    z-index: 100;
    padding-top: 50px;
}

.btnAsideAction {
    position: absolute;
    bottom: -20px;
    top: initial;
    left: 0;
    width: 100%;
    height: 40px;
    background-color: #343435;
    cursor: pointer;
    padding: 10px 4px 4px 4px;
    line-height: 21px;
    text-align: center;
    color: #fff;
    display: none;
}

aside.left-sidebar.min .scroll-sidebar {
    height: 100%;
}
aside.left-sidebar.min .scroll-sidebar .btnAsideAction {
    bottom: 0px;
}
aside.left-sidebar.min .scroll-sidebar .btnAsideAction i:before {
    content: "\f054";
}
aside.left-sidebar.min, .left-sidebar, .sidebar-nav ul .sidebar-item {
    width: 115px;
}
aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item,
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item
    ul.collapse.first-level
    li.sidebar-item {
    width: 115px;
    transition: all 0.5s ease-out;
    position: relative;
}

aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    ul.collapse.first-level,
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    ul.collapse.first-level.in {
    position: absolute;
    top: 0px;
    left: 40px;
    width: 170px;
}

aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item
    a.sidebar-link
    span.hide-menu,
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item
    div.sidebar-link
    span.hide-menu,
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item
    ul.collapse.first-level,
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item
    ul.collapse.first-level.in {
    display: block;
}
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    ul.collapse.first-level,
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    ul.collapse.first-level.in,
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    ul.collapse.first-level
    li.sidebar-item
    a.sidebar-link
    span.hide-menu {
    display: block;
}
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    ul.collapse.first-level
    li.sidebar-item
    a.sidebar-link {
    border-left: 2px solid transparent;
}
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    a.sidebar-link,
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    div.sidebar-link.has-arrow.waves-effect.waves-dark,
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    div.sidebar-link.has-arrow.waves-effect.waves-dark.active {
    border-left: 2px solid #00b04b;
    opacity: 1;
    background-color: #555;
}
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    div.sidebar-link,
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item:hover
    ul.collapse.first-level {
    background: #191919;
}
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item
    > .has-arrow::after {
    transition: all 0.5s ease-out;
}
aside.left-sidebar.min
    .scroll-sidebar
    nav.sidebar-nav
    ul#sidebarnav
    li.sidebar-item
    > .has-arrow::after {
    -webkit-transform: rotate(135deg) translate(0, -50%) !important;
    transform: rotate(135deg) translate(0, -50%) !important;
}
a.sidebar-link.waves-effect.waves-dark {
    display: flex;
    flex-direction: column;
}
.sidebar-nav ul .sidebar-item .sidebar-link i {
    line-height: 10px;
}
.sidebar-nav > #sidebarnav > .sidebar-item > .active.router-link-active {
    border-left: 2px solid #00b04b;
    color: #fff;
    opacity: 1;
    background-color: #555;
}
#main-wrapper[data-layout="vertical"]
    .left-sidebar[data-sidebarbg="skin5"]
    .sidebar-nav
    > #sidebarnav
    > .sidebar-item
    > .sidebar-link:hover,
#main-wrapper[data-layout="horizontal"]
    .left-sidebar[data-sidebarbg="skin5"]
    .sidebar-nav
    > #sidebarnav
    > .sidebar-item
    > .sidebar-link:hover {
    border-left: 2px solid #00b04b;
}
span.hide-menu {
    margin-top: 5px;
    font-size: 14px;
}
.sidebar-nav ul .sidebar-item .sidebar-link {
    padding: 12px 0px 8px 0px;
    line-height: 1.5;
    margin-bottom: 10px;
}
@media (max-width: 1024px) {
    .sidebar-nav ul .sidebar-item .sidebar-link {
        padding: 12px 0px 8px 0px;
    }
}
</style>
